export enum Scenarios {
    LibroDiarioEscenario = 'LibroDiarioEscenario',
    DocumentDetail = 'DOCUMENTODETALLE',
}
